import { TableBody, TableCell, TableRow } from "@windmill/react-ui";

import TripadvanceDrawer from "components/drawer/TripadvanceDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import Tooltip from "@mui/material/Tooltip";
import ItineraryModal from "components/form/ItineraryModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import React, { useState, useContext } from "react";
import { SidebarContext } from "context/SidebarContext";
import { FiEdit, FiFile } from "react-icons/fi";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import RequestModal from "components/modal/RequestModal";
import { MdClose } from "react-icons/md";
import { notifyError, notifySuccess } from "utils/toast";
import TripadvanceServices from "services/TripadvanceServices";
import StatusModal from "components/modal/StatusModal";
import { FaInfoCircle } from "react-icons/fa";
const TripadvanceTable = ({
  tripadvance,
  perpage,
  currentPage,
  tab,
  hideView,
  hideEdit,
  hideExport,
  hideAdd,
}) => {
  const { title, serviceId } = useToggleDrawer();
  const [showItineraryModal, setShowItineraryModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [requestAmount, setRequestAmount] = useState("");
  const [error, setError] = useState("");
  const [selectedData, setSelectedData] = useState(null);
  const [selectedTripadvance, setSelectedTripadvance] = useState(null);
  const [retrictedAmount, setRetrictedAmount] = useState(0);

  const { setIsUpdate } = useContext(SidebarContext);
  const [isRemarkModalOpen, setIsRemarkModalOpen] = useState(false);
  const [itinerary, setItinerary] = useState("");
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(0);
  const [selectedRemark, setSelectedRemark] = useState("");

  const handleOpen = (id, tripadvance, restrict_amount) => {
    setIsRemarkModalOpen(true);
    setId(id);
    setSelectedTripadvance(tripadvance);

    setRetrictedAmount(restrict_amount);
  };

  const handleClick = (data) => {
    setSelectedData(data);
    setShowModal(true);
  };

  const closeModal = () => {
    setIsRemarkModalOpen(false);
    setShowModal(false);
    setSelectedTripadvance(null);
  };

  const handleAmountChange = (e) => {
    setRequestAmount(e.target.value);
  };
  const handleSubmit = async (data, requestAmount) => {
    const tripAdvanceRequest = parseFloat(requestAmount) || 0;

    const payload = {
      // client_id: data.va_client_id,
      va_id: data.va_id,
      // vendor_id: data.va_vendor_id,
      // current_driver_id: data.va_driver_id,
      trip_advance_request: tripAdvanceRequest,
    };

    try {
      const response =
        await TripadvanceServices.tripadvanceRequestList(payload);
      //   console.log("--------", response);

      if (response?.status) {
        notifySuccess(response.message);
        setIsUpdate(true);
        closeModal();
      } else {
        setError("Failed to submit the trip advance request.");
        notifySuccess(response.data.message);
      }
    } catch (error) {
      console.error("API Error:", error);
      setError("An error occurred while submitting the trip advance request.");
      notifyError(
        error?.response?.data?.message ||
          "An error occurred while submitting the trip advance request.",
      );
    }
  };

  const handleModalAction = async (amount, remark, id) => {
    if (!id || amount === undefined || !remark?.trim()) {
      notifyError("Amount or Remark is missing.");
      return;
    }

    try {
      const response = await TripadvanceServices.tripadvanceRequest(id, {
        amount,
        remark,
      });

      if (response.status) {
        setIsUpdate(true);
        notifySuccess(response.message);
      } else {
        notifyError(response.message || "Failed to update status.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      notifyError(
        error?.response?.data?.message || "Unexpected error occurred.",
      );
    } finally {
      setIsRemarkModalOpen(false);
    }
  };

  const handleClose = () => setOpen(false);

  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <TripadvanceDrawer id={serviceId} />
      </MainDrawer>

      <RequestModal
        title="Trip Advance Request"
        isOpen={showModal}
        onClose={closeModal}
        handleSubmit={handleSubmit}
        data={selectedData}
        groupedData={selectedData}
        requestAmount={requestAmount}
        handleAmountChange={handleAmountChange}
        error={error}
      />
      <StatusModal
        isOpen={isRemarkModalOpen}
        onClose={() => setIsRemarkModalOpen(false)}
        title="Re-Request"
        onYesClick={(requestAmount, remark, id) =>
          handleModalAction(requestAmount, remark, id)
        }
        id={id}
        data={selectedTripadvance}
        retrictedAmount={retrictedAmount}
      />

      <ItineraryModal
        isOpen={showItineraryModal}
        content={itinerary}
        onClose={() => setShowItineraryModal(false)}
      />

      <TableBody>
        {tripadvance.slice(0, perpage).map((data, index) => {
          // const advances = data.trip_advances?.length
          //   ? data.trip_advances
          //   : [
          //       {
          //         id: data.id,
          //         trip_advance_request: data.trip_advance_request,
          //         approval_status: data.approval_status,
          //         approved_remark: data.approved_remark,
          //         rerequest_remark: data.rerequest_remark,
          //         restrict_amount: data.restrict_amount,
          //         trip_advance_paid: data.trip_advance_paid,
          //         payment_type: data.payment_type,
          //         utr: data.utr,
          //         paid_date: data.paid_date,
          //         paid_remark: data.paid_remark,
          //         trip_went_or_not: data.trip_went_or_not,
          //         status: data.status,
          //       },
          //     ];
          const advances = data.trip_advances ?? [];
          const lastTripAdvance = advances[advances.length - 1];
          return (
            <TableRow
              key={data.id || index}
              className={
                data.booking_status === 1
                  ? "text-center bg-red-100 dark:bg-gray-500"
                  : "text-center"
              }
            >
              <TableCell className="text-center text-sm">
                {(currentPage - 1) * perpage + index + 1}
              </TableCell>
              <TableCell className="text-sm">{data.ref_no}</TableCell>

              <TableCell className="text-sm">{data.client_name}</TableCell>
              <TableCell className="text-sm">
                <div className="flex flex-col row-gap-4 text-sm">
                  <p className="m-0">{data.start_date}</p>

                  <p className="m-0">{data.end_date}</p>
                </div>
              </TableCell>

              <TableCell className="text-sm">
                <div className="flex flex-col row-gap-4 text-sm">
                  <p className="m-0">{data.arrival}</p>

                  <p className="m-0">{data.departure}</p>
                </div>
              </TableCell>
              {/* {console.log(data)} */}
              <TableCell className="text-sm">{data.no_of_days}</TableCell>
              <TableCell className="text-sm">{data.vehicle_type}</TableCell>
              {tab === 0 && (
                <TableCell>
                  {data.itinerary && (
                    <div
                      className="flex flex-col items-center justify-center text-green-600 cursor-pointer"
                      onClick={() => {
                        setShowItineraryModal(true);
                        setItinerary(data.itinerary);
                      }}
                      title="Itinerary"
                    >
                      <FiFile size={"25px"} />
                    </div>
                  )}
                </TableCell>
              )}

              <TableCell className="text-sm ">{data.vendor_name}</TableCell>
              <TableCell className="text-sm ">
                <p>{data.va_start_date}</p>
                <p>{data.va_end_date}</p>
              </TableCell>

              <TableCell className="text-sm">
                {advances?.map((item, i) => (
                  <div className="mb-3" key={i}>
                    {item.trip_advance_request ?? "-"}

                    {tab === 0 && item.approval_status === "Rejected" && (
                      <button
                        onClick={() =>
                          handleOpen(
                            item.id,
                            item.trip_advance_request,
                            data.restrict_amount,
                          )
                        }
                        className="px-3 py-2 cursor-pointer text-gray-400 hover:text-green-600"
                      >
                        <FiEdit />
                      </button>
                    )}
                  </div>
                ))}
              </TableCell>

              <TableCell className="text-sm">
                {advances.map((item, i) => {
                  const getStatusClass = (status) => {
                    switch (status) {
                      case "Approved":
                        return "text-green-600 font-semibold";
                      case "Rejected":
                        return "text-red-600 font-semibold";
                      case "Awaiting for Approval":
                        return "text-yellow-600 font-semibold";
                      case "Partially Paid":
                        return "text-blue-600 font-semibold";
                      case "Paid":
                        return "text-green-700 font-semibold";
                      case "Awaiting for Payment":
                        return "text-orange-500 font-semibold";
                      case "Request":
                        return "text-pink-500 font-semibold";
                      default:
                        return "text-gray-600";
                    }
                  };

                  return (
                    <div
                      key={i}
                      className={`${getStatusClass(item.status)}  mb-3 text-sm flex items-center justify-center gap-2`}
                    >
                      <p className="mb-0 text-center text-sm">{item.status}</p>
                      {(item?.status === "Partially Paid" || item?.status === "Paid") && (
                        <div>
                          <Tooltip
                            title={
                              <div className="text-xs">
                                {item?.payments || `Paid Amount : ${item?.trip_advance_paid}`}
                              </div>
                            }
                            placement="top"
                            componentsProps={{
                              tooltip: {
                                sx: { fontSize: "12px", padding: "8px" },
                              },
                            }}
                          >
                            <span
                              className="text-blue-500 cursor-pointer"
                              aria-label="View arrival details"
                            >
                              <FaInfoCircle />
                            </span>
                          </Tooltip>
                        </div>
                      )}
                    </div>
                  );
                })}
              </TableCell>

              {/* {console.log(data)}  */}
              {(() => {
                const [day, month, year] = data.start_date.split("-");

                const startDate = new Date(`${year}-${month}-${day}`);
                const [days, months, years] = data.end_date.split("-");

                const endDate = new Date(`${years}-${months}-${days}`);
                const currentDate = new Date();
                currentDate.setHours(0, 0, 0, 0); // remove time part
                startDate.setHours(0, 0, 0, 0);
                endDate.setHours(0, 0, 0, 0);
                // console.log(
                // 	currentDate <= startDate,
                // 	currentDate <= endDate,
                // 	startDate,
                // 	endDate
                // );
                return (
                  currentDate <= startDate ||
                  currentDate <= endDate ||
                  data.client_status === "Inactive"
                );
              })() ? (
                <>
                  {tab === 0 && (
                    // <TableCell>
                    //   {data.booking_status === 1 ? (
                    //     //  Cancelled booking → dash only
                    //     <span className="text-gray-500">-</span>
                    //   ) : data.trip_completed == 0 ? (
                    //     lastTripAdvance?.trip_went_or_not == "2" ? (
                    //       // Show "Trip Not Went" if trip_went_or_not is 2
                    //       <span className="text-red-500 font-semibold">
                    //         Trip Not Went
                    //       </span>
                    //     ) : data.client_status !== "Inactive" ? (
                    //       //  Otherwise show buttons
                    //       lastTripAdvance?.status === "Request" &&
                    //       lastTripAdvance?.approval_status == null ? (
                    //         <button
                    //           className="ml-2 px-2 py-1 text-sm text-white bg-blue-500 rounded hover:bg-blue-600"
                    //           onClick={() => handleClick(data)}
                    //         >
                    //           Request
                    //         </button>
                    //       ) : (
                    //         <button
                    //           className="ml-2 px-2 py-1 text-sm text-white bg-blue-500 rounded hover:bg-blue-600"
                    //           onClick={() => handleClick(data)}
                    //         >
                    //           Request More
                    //         </button>
                    //       )
                    //     ) : (
                    //       <span className="text-gray-500">-</span>
                    //     )
                    //   ) : (
                    //     <span className="text-gray-500">-</span>
                    //   )}
                    // </TableCell>

                    <TableCell>
                      {data.show_request_button ? (
                        hideEdit === true ? (
                          <button
                            className="ml-2 px-2 py-1 text-sm text-white bg-blue-500 rounded hover:bg-blue-600"
                            onClick={() => handleClick(data)}
                          >
                            {data.request_button_label}
                          </button>
                        ) : (
                          "-"
                        )
                      ) : (
                        <span
                          className={`font-semibold text-sm ${
                            data.action_status === "Cancelled"
                              ? "text-red-600"
                              : data.action_status === "Vendor Has Been Changed"
                                ? "text-orange-400"
                                : data.action_status === "Completed"
                                  ? "text-green-600"
                                  : "text-gray-500"
                          }`}
                        >
                          {data.action_status || "-"}
                        </span>
                      )}
                    </TableCell>
                  )}
                </>
              ) : (
                <>
                  {tab === 0 && (
                    <TableCell>
                      {data.booking_status === 1 ? (
                        <p className="text-red-600 font-semibold mb-3 text-sm">
                          Cancelled
                        </p>
                      ) : (
                        <span className="text-green-600 font-semibold">
                          Completed
                        </span>
                      )}
                    </TableCell>
                  )}
                </>
              )}
            </TableRow>
          );
        })}
      </TableBody>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 300,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
          }}
        >
          {/* Close Icon */}
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <MdClose size={24} />
          </IconButton>

          <Typography variant="body1" sx={{ mt: 4 }}>
            {selectedRemark}
          </Typography>
        </Box>
      </Modal>
    </>
  );
};

export default TripadvanceTable;
